<div class="content">
    <h4>{{'productsdownload.processor.title'|translateTA}}</h4>
    <div class="text-content">
        <textarea nz-input readonly class="log-textarea" [(ngModel)]="texto"></textarea>
    </div>
    <div class="pb-content">
        <nz-progress [nzPercent]="percent" nzStatus="active" [nzShowInfo]="true"></nz-progress>
    </div>
    <div class="button-content">
        <span><button type="button" nz-button nzType="primary" (click)="sair()"
                [disabled]="disabled">{{'productsdownload.processor.exit'|translateTA}}</button></span>
    </div>
</div>
